import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { createUUID } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { open } from '../../../../../modules/identityDocumentScanner/actions';

interface Props {
    openDialog?: $TSFixMeFunction;
    close?: $TSFixMeFunction;
    action?: {};
}

class IdentityDocumentScannerAction extends Component<Props> {
    handleOpenScannerDialog = () => {
        const id = createUUID();

        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.openDialog(id);

        // closes item menu
        if (this.props.close) {
            this.props.close();
        }
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'component' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { component, action } = this.props;
        // @ts-expect-error $TSFixMeError: Property 'icon' does not exist on type '{} | undefined'.
        const { icon, disabled } = action;

        return createElement(component, {
            icon,
            disabled,
            title: <LocalizedText textKey={TextKey.MewsIdentityScanner} />,
            onClick: this.handleOpenScannerDialog,
        });
    }
}

// @ts-expect-error $TSFixMeError: Property 'action' does not exist on type '{}'.
export default connect(undefined, (dispatch: CommanderThunkDispatch, { action }) => ({
    openDialog: (id: string) => dispatch(open(id, action.customerId)),
}))(IdentityDocumentScannerAction);
